// extracted by mini-css-extract-plugin
export default {"mypage_subsc_go_and_back_buttons":"go-and-back_mypage_subsc_go_and_back_buttons__rYRHa"};